import React, { useState } from 'react';
import { Button, ChevronDown, ChevronUp } from '@opendate-app/setlist';

const EXPANDED_ROWS = [
  { key: 'address1', label: 'Address' },
  { key: 'address2', label: 'Address 2' },
  { key: 'city', label: 'City' },
];

function AddAffordance({ label, onAdd }) {
  return (
    <Button variant="link-color" size="sm" onClick={onAdd} aria-label={`Add ${label}`}>
      + Add
    </Button>
  );
}

function ContactInfoCard({ contact = {}, onAdd = () => {}, children = null }) {
  const [expanded, setExpanded] = useState(false);
  const phone = contact.human_phone || contact.phone || null;
  const birthday = contact.birthday
    ? new Date(`${contact.birthday}T00:00:00`).toLocaleDateString()
    : null;

  return (
    <div className="cdp-card">
      <h2 className="cdp-card-title">Contact Info</h2>

      <div className="cdp-side-row">
        <span className="cdp-side-row-label">Email</span>
        <span className="cdp-side-row-value">
          {contact.email ? <a href={`mailto:${contact.email}`}>{contact.email}</a> : '--'}
        </span>
      </div>

      <div className="cdp-side-row">
        <span className="cdp-side-row-label">Phone</span>
        <span className="cdp-side-row-value">
          {phone || <AddAffordance label="Phone" onAdd={onAdd} />}
        </span>
      </div>

      <div className="cdp-side-row">
        <span className="cdp-side-row-label">State</span>
        <span className="cdp-side-row-value">
          {contact.state || <AddAffordance label="State" onAdd={onAdd} />}
        </span>
      </div>

      <div className="cdp-side-row">
        <span className="cdp-side-row-label">Zip</span>
        <span className="cdp-side-row-value">
          {contact.zip || <AddAffordance label="Zip" onAdd={onAdd} />}
        </span>
      </div>

      {expanded && (
        <>
          <div className="cdp-side-row">
            <span className="cdp-side-row-label">Secondary Email</span>
            <span className="cdp-side-row-value">
              {contact.email_secondary_1 || <AddAffordance label="Secondary Email" onAdd={onAdd} />}
            </span>
          </div>

          <div className="cdp-side-row">
            <span className="cdp-side-row-label">Birthday</span>
            <span className="cdp-side-row-value">
              {birthday || <AddAffordance label="Birthday" onAdd={onAdd} />}
            </span>
          </div>

          {EXPANDED_ROWS.map(({ key, label }) => (
            <div className="cdp-side-row" key={key}>
              <span className="cdp-side-row-label">{label}</span>
              <span className="cdp-side-row-value">
                {contact[key] || <AddAffordance label={label} onAdd={onAdd} />}
              </span>
            </div>
          ))}

          {children}
        </>
      )}

      <div className="cdp-card-footer cdp-card-footer--center">
        <Button variant="link-gray" size="sm" onClick={() => setExpanded((prev) => !prev)}>
          <span className="cdp-see-more-label">
            {expanded ? 'See Less' : 'See More'}
            {expanded ? <ChevronUp width={16} height={16} /> : <ChevronDown width={16} height={16} />}
          </span>
        </Button>
      </div>
    </div>
  );
}

export default ContactInfoCard;
